import gql from 'graphql-tag'
import di from 'di'

import addList from '@wittignl/js-core/apollo/mutations/addList'
import updateList from '@wittignl/js-core/apollo/mutations/updateList'
import deleteList from '@wittignl/js-core/apollo/mutations/deleteList'

export default {

    update: function(item){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($repairInput: UpdateRepairInput!) {
                    updateRepair(input: $repairInput){
                        id
                        reference
                        endDate
                    }
                }`,

            variables: {
                repairInput: item
            },

            updateQueries: {
                AllRepairs: updateList('updateRepair', 'allRepairs.items')
            }
        });
    }
}
